import store from '@store';

export default {
  methods: {
    currentCompanyId() {
      return store.state.userInformation.companyId;
    },
  },
};
